import React from 'react';
import '../../css/vers2/ActivitiesRatesSection.css';

type ActivitiesRatesSectionProps = {
    setPage: React.Dispatch<React.SetStateAction<string>>;
};

const ActivitiesRatesSection = ({ setPage }: ActivitiesRatesSectionProps) => {
    return (
        <section id="dagindeling" className="activities-section page-section">
            <img className="daily-icon yellow-title-drop" src="/icons/daily_activities/yellowDrop.png" alt="" />
            <img className="daily-icon yellow-lines" src="/icons/daily_activities/yellowLines.png" alt="" />
            <img className="daily-icon purple-stars" src="/icons/daily_activities/purpleStars.png" alt="" />
            <img className="daily-icon three-drops" src="/icons/daily_activities/threeDrops.png" alt="" />
            <img className="daily-icon blue-drop" src="/icons/daily_activities/blueDrop.png" alt="" />

            <h2 className="daily-title">
                <span className="daily-title-word">Daily</span>{' '}
                <span className="daily-title-word">Activities</span>
            </h2>

            <div className="activity-grid">

                <div className="activity-card pink-activity">
                    <img
                        className="blob-bg"
                        src="/icons/daily_activities/lightPinkBig.png"
                        alt=""
                    />

                    <div className="activity-content">
                        <h3>Dagindeling</h3>

                        <p>
                            Tijdens de opvang streef ik ernaar zoveel mogelijk rust, ritme en regelmaat te bieden.
                            De dagen verlopen veelal hetzelfde, maar zo nu en dan gaan we er ook wel eens even op uit.
                            Zoals een dagje naar een grote buitenspeeltuin.
                        </p>

                        <p className="schedule-lines">
                            <span>Onze dagen zien er ongeveer zo uit:</span><br />
                            <span>07:00 – 08:30 kinderen worden gebracht</span><br />
                            <span>08:30 – 09:00 mogen de kinderen vrijspelen</span><br />
                            <span>09:15 – 10:00 fruit eten en drinken daarna voorlezen en liedjes zingen</span><br />
                            <span>10:00 – kindjes die slapen gaan naar bed</span><br />
                            <span>10:00 – 10:30 vrijspelen binnen of buiten</span><br />
                            <span>10:40 – Knutsel activiteit</span><br />
                            <span>11:30 – lunch</span><br />
                            <span>12:30 – Kinderen die slapen gaan naar bed</span><br />
                            <span>14:30 – Snack moment + drinken</span><br />
                            <span>15:00 – Bedtijd voor kinderen die 2x slapen</span><br />
                            <span>15:00 – 15:30 Groepsactiviteit</span><br />
                            <span>15:45 – vrij spelen</span><br />
                            <span>17:15 – 18:00 Afsluiting van de dag</span>
                        </p>
                    </div>
                </div>

                <div className="activity-card orange-activity">
                    <img
                        className="blob-bg"
                        src="/icons/daily_activities/lightPurpleBig.png"
                        alt=""
                    />

                    <div className="activity-content">
                        <h3>Tarieven</h3>

                        <p>
                            <strong>Tarief normaal contract: €7,25</strong>
                        </p>

                        <p>
                            Naast het tarief van de gastouder worden er ook bemiddelingskosten aan het
                            gastouderbureau betaald. (Dit geldt alleen als je via een gastouderbureau je kind aanmeldt)
                        </p>

                        <p>
                            Omdat ik geregistreerd sta in het landelijk register kinderopvang en
                            peuterspeelzalen ontvangen ouders kinderopvangtoeslag.
                        </p>

                        <p>
                            Ouders hebben alleen recht op kinderopvangtoeslag wanneer zij zich via een
                            gastouderbureau aanmelden. Voor deze toeslag werk ik samen met gastouderbureau
                            4 Kids en Mare.
                        </p>

                        <p>
                            Alleen bij afwezigheid van de gastouder wordt er geen vergoeding betaald.
                            (Bij vakantie en ziekte van de gastouder)
                        </p>

                        <p>
                            Tariefwijzigingen van de gastouder worden tenminste 1 maand van te voren doorgegeven.
                        </p>
                    </div>
                </div>
            </div>

            <img
                className="daily-girl"
                src="/icons/daily_activities/girl.png"
                alt=""
            />
        </section>
    );
};

export default ActivitiesRatesSection;